<template>
  <Modal :option="'filter'" @close="$emit('close')">
    <div class="p-modal__content__header">
      {{ $t('labels.selectFilterCond') }}
    </div>
    <div class="p-modal__content__body">
      <div class="p-filters">
        <FilterItem v-for="item in filterItems" :key="item.type"
                    :list="item.tags"
                    :head-text="item.headText"
                    :filter-name="item.filterName"
                    :filter-type="item.type"
                    :value-key="item.valueKey"
                    :store-name="storeName"
        />
      </div>
    </div>
    <div class="p-modal__content__footer">
      <div class="store-count-wap">{{ $t('labels.targetStoreCount') }}<span class="store-count">{{ totalCount }}</span>{{ $t('labels.storeCountUnit') }}</div>
      <div class="c-button c-button--right">
        <button
          type="button"
          class="c-button__item c-button__item--outline-cancel"
          :disabled="searchAttributesLoading"
          @click="$emit('submit')"
          v-text="$t('labels.checkTargetStores')"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Modal from './Modal'
import FilterItem from './FilterItem'

export default {
  name: 'FilterModal',
  components: {
    Modal,
    FilterItem
  },
  props: {
    disableFilterItemTypes: {
      type: Array,
      default: () => []
    },
    excludeBusinessTypes: {
      type: Array,
      default: () => []
    },
    targetServices: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close', 'submit'],
  computed: {
    ...mapState({
      searchAttributesLoading: state => state.companiesSearchTagGroups.loading,
      brands: state => state.companiesSearchTagGroups.data.brands,
      franchisees: state => state.companiesSearchTagGroups.data.franchisees,
      areas: state => state.companiesSearchTagGroups.data.areas,
      userCompanies: state => state.companiesSearchTagGroups.data.user_companies,
      prefectures: state => state.companiesSearchTagGroups.data.prefectures,
      totalCount: state => state.companiesGmbSearchStores.storeTotalCount,
      formValues: state => state.companiesSearchTagGroups.formValues,
      changeCheckBox: state => state.companiesSearchTagGroups.changeCheckBox,
      originalTagGroupA : state => state.companiesSearchTagGroups.data.original_tag_group_a,
      originalTagGroupB : state => state.companiesSearchTagGroups.data.original_tag_group_b,
      originalTagGroupC : state => state.companiesSearchTagGroups.data.original_tag_group_c,
      originalTagGroupD : state => state.companiesSearchTagGroups.data.original_tag_group_d,
      originalTagGroupE : state => state.companiesSearchTagGroups.data.original_tag_group_e,
    }),
    filterItems() {
      const arr = [
        this.addAttributes(this.brands, this.brands.kind),
        this.addAttributes(this.prefectures, this.prefectures.kind),
        this.addAttributes(this.areas, this.areas.kind),
        this.addAttributes(this.franchisees, this.franchisees.kind),
        this.addAttributes(this.userCompanies, this.userCompanies.kind),
      ]
      if(this.originalTagGroupA) arr.push(this.addAttributes(this.originalTagGroupA, this.originalTagGroupA.kind))
      if(this.originalTagGroupB) arr.push(this.addAttributes(this.originalTagGroupB, this.originalTagGroupB.kind))
      if(this.originalTagGroupC) arr.push(this.addAttributes(this.originalTagGroupC, this.originalTagGroupC.kind))
      if(this.originalTagGroupD) arr.push(this.addAttributes(this.originalTagGroupD, this.originalTagGroupD.kind))
      if(this.originalTagGroupE) arr.push(this.addAttributes(this.originalTagGroupE, this.originalTagGroupE.kind))
      return arr.filter(v => !this.disableFilterItemTypes.includes(v.type))
    },
    companyUuid() {
      return this.$route.params.company_uuid
    },
    storeName(){
      return 'companiesSearchTagGroups'
    }
  },
  watch: {
    changeCheckBox() {
      const params = {
        companyUuid: this.companyUuid,
        formValues: this.formValues,
        excludeBusinessTypes: this.excludeBusinessTypes
      }
      if (this.targetServices.length >= 2) {
        params.onlyConnectedGmb = false
        params.onlyConnectedYahooPlace = false
      } else {
        params.onlyConnectedGmb = this.targetServices.includes('google_map')
        params.onlyConnectedYahooPlace = this.targetServices.includes('yahoo_map')
      }
      this.readStores(params)
    }
  },
  methods: {
    ...mapActions({
      readStores: 'companiesGmbSearchStores/readStores'
    }),
    addAttributes(item, type) {
      item.type = type
      item.headText = this.$te('models.filterItem.' + type + '.headText') ? this.$t('models.filterItem.' + type + '.headText') : this.$t('models.filterItem.all.headText')
      item.filterName = this.$te('models.filterItem.' + type + '.filterName') ? this.$t('models.filterItem.' + type + '.filterName') : item.label
      return item
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';

.p-modal {
  &__content {
    &__footer {
      padding: 12px 32px;
      border-top: 1px solid $color-base-c;
    }
  }
}
.p-modal--filter {
  :deep(.p-modal__content) {
    width: 1076px;
  }

.store-count-wap {
  position: absolute;
  bottom: 5px;
  right: 200px;
}

.store-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}
}
.c-checkbox {
  padding: 24px;
}
</style>
